import React from 'react';

type BadgeVariant = 'active' | 'needs-feeding' | 'fed' | 'harvest-ready' | 'resting' | 'warning' | 'healthy' | 'fair' | 'poor' | 'grade-a' | 'grade-b' | 'grade-c';

const variantStyles: Record<BadgeVariant, string> = {
  active: 'bg-success-bg text-success border-success/20',
  'needs-feeding': 'bg-warning-bg text-warning-foreground border-warning/30',
  fed: 'bg-secondary text-secondary-foreground border-accent/20',
  'harvest-ready': 'bg-info-bg text-info border-info/20',
  resting: 'bg-muted text-muted-foreground border-border',
  warning: 'bg-danger-bg text-danger border-danger/20',
  healthy: 'bg-success-bg text-success border-success/20',
  fair: 'bg-warning-bg text-warning-foreground border-warning/30',
  poor: 'bg-danger-bg text-danger border-danger/20',
  'grade-a': 'bg-success-bg text-success border-success/20',
  'grade-b': 'bg-secondary text-secondary-foreground border-accent/20',
  'grade-c': 'bg-warning-bg text-warning-foreground border-warning/30',
};

const labels: Record<BadgeVariant, string> = {
  active: 'Active',
  'needs-feeding': 'Needs Feeding',
  fed: 'Fed',
  'harvest-ready': 'Harvest Ready',
  resting: 'Resting',
  warning: 'Warning',
  healthy: 'Healthy',
  fair: 'Fair',
  poor: 'Poor',
  'grade-a': 'Grade A',
  'grade-b': 'Grade B',
  'grade-c': 'Grade C',
};

export default function StatusBadge({ variant }: { variant: BadgeVariant }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${variantStyles[variant]}`}
    >
      {labels[variant]}
    </span>
  );
}